import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { UBXContainer } from './container.component';

const Module = [
    UBXContainer
];

@NgModule({
    declarations: [
        Module
    ],
    imports: [
        CommonModule
    ],
    exports: [
        Module
    ],
})
export class UBXContainerModule {}
